import script from "./password.vue?vue&type=script&setup=true&lang=js"
export * from "./password.vue?vue&type=script&setup=true&lang=js"

import "./password.vue?vue&type=style&index=0&id=5c5eb454&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-production-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c5eb454"]])

export default __exports__